import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';
import { EventType } from '@principle-theorem/principle-core/interfaces';

export interface IScheduleSummaryDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  events: IBigQueryScheduleSummaryEvent[];
  staffer: ISerialisedDocumentReference;
  practice: ISerialisedDocumentReference;
  day: string;
}

export interface IBigQueryScheduleSummaryEvent {
  from: ISerialisedTimestamp;
  to: ISerialisedTimestamp;
  type: EventType;
  ref: ISerialisedDocumentReference;
  isBlocking: boolean;
}
